import { Typography, Skeleton, Grid, Stack, Box, Button } from "@mui/material";

interface Props {
  onCancel: () => void;
}

const ValidationStatusSkeleton = ({ onCancel }: Props) => {
  return (
    <Box sx={{ p: 2.5 }}>
      {/* Title */}
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Almost there!
      </Typography>

      {/* Subtitle */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Checking your integration status...
      </Typography>

      {/* Top placeholders */}
      <Grid container spacing={3} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Skeleton variant="rounded" width={55} height={18} sx={{ mb: 1 }} />
          <Skeleton variant="rounded" width="100%" height={14} />
        </Grid>

        <Grid item xs={6}>
          <Box display="flex" justifyContent="center">
            <Skeleton variant="rounded" width={55} height={18} sx={{ mb: 1 }} />
          </Box>
          <Skeleton variant="rounded" width="100%" height={14} />
        </Grid>
      </Grid>

      {/* Table-like rows */}
      <Stack spacing={1}>
        {Array.from({ length: 8 }).map((_, index) => (
          <Grid container spacing={2} key={index}>
            <Grid item xs={7}>
              <Skeleton variant="rounded" height={14} animation="wave" />
            </Grid>
            <Grid item xs={5}>
              <Skeleton variant="rounded" height={14} animation="wave" />
            </Grid>
          </Grid>
        ))}
      </Stack>

      {/* Footer */}
      <Box
        sx={{
          mt: 4,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Button
          variant="text"
          onClick={onCancel}
          sx={{ color: "#9C27B0", fontWeight: 600, minWidth: "auto", p: 0 }}
        >
          Cancel
        </Button>
        <Button variant="contained" disabled sx={{ minWidth: 92, height: 36 }}>
          Approve
        </Button>
      </Box>
    </Box>
  );
};

export default ValidationStatusSkeleton;
